import gql from 'graphql-tag'

export const subsidiaryQuery = gql`
  query GetCountriesSubsidiaries {
    countriesSubsidiaries {
      id
      country
      subsidiary
      countryCode: country_code
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ConfirmCountryDialog/data.ts